export enum UniverseEnum {
    MIXED = 'MIXED',
    ORANGE = 'ORANGE',
    SOSH = 'SOSH',
}
